export default __webpack_public_path__ + "static/media/personalDetails@2x.2d7d81b2.png";